module.exports = __webpack_public_path__ + "officialStatic/img/newsBg.d38b2df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/newsBg.jpg
// module id = PEC4
// module chunks = 0